import { performRequest } from "../performRequest"

const withCompany = (params) => {
    const company = localStorage.getItem('company') || 1
    return { ...params, company }
}

// ==================== SIZES ====================
export const getUniformSizesApi = (params) => {
    return performRequest("get", "api/uniform/sizes/", params)
}

export const getUniformSizeDetailApi = (id, params) => {
    return performRequest("get", `api/uniform/sizes/${id}/`, params)
}

export const createUniformSizeApi = (params) => {
    return performRequest("post", "api/uniform/sizes/", withCompany(params))
}

export const updateUniformSizeApi = (id, params) => {
    return performRequest("put", `api/uniform/sizes/${id}/`, withCompany(params))
}

export const deleteUniformSizeApi = (id) => {
    return performRequest("delete", `api/uniform/sizes/${id}/`)
}

// ==================== ITEMS ====================
export const getUniformItemsApi = (params) => {
    return performRequest("get", "api/uniform/items/", params)
}

export const getUniformItemDetailApi = (id, params) => {
    return performRequest("get", `api/uniform/items/${id}/`, params)
}

export const createUniformItemApi = (params) => {
    return performRequest("post", "api/uniform/items/", withCompany(params))
}

export const updateUniformItemApi = (id, params) => {
    return performRequest("put", `api/uniform/items/${id}/`, withCompany(params))
}

export const deleteUniformItemApi = (id) => {
    return performRequest("delete", `api/uniform/items/${id}/`)
}

// ==================== POSITION MAPPINGS ====================
export const getPositionMappingsApi = (params) => {
    return performRequest("get", "api/uniform/positions/", params)
}

export const getPositionMappingDetailApi = (id, params) => {
    return performRequest("get", `api/uniform/positions/${id}/`, params)
}

export const createPositionMappingApi = (params) => {
    return performRequest("post", "api/uniform/positions/", withCompany(params))
}

export const updatePositionMappingApi = (id, params) => {
    return performRequest("put", `api/uniform/positions/${id}/`, withCompany(params))
}

export const deletePositionMappingApi = (id) => {
    return performRequest("delete", `api/uniform/positions/${id}/`)
}

// ==================== WAREHOUSES ====================
export const getWarehousesApi = (params) => {
    return performRequest("get", "api/uniform/warehouses/", params)
}

export const getWarehouseDetailApi = (id, params) => {
    return performRequest("get", `api/uniform/warehouses/${id}/`, params)
}

export const createWarehouseApi = (params) => {
    return performRequest("post", "api/uniform/warehouses/", withCompany(params))
}

export const updateWarehouseApi = (id, params) => {
    return performRequest("put", `api/uniform/warehouses/${id}/`, withCompany(params))
}

export const deleteWarehouseApi = (id) => {
    return performRequest("delete", `api/uniform/warehouses/${id}/`)
}

// ==================== WAREHOUSE STOCK ====================
export const getWarehouseStockApi = (warehouseId, params) => {
    return performRequest("get", `api/uniform/warehouses/${warehouseId}/stock/`, params)
}

// ==================== STOCK RECEIVING ====================
export const receiveStockApi = (params) => {
    return performRequest("post", "api/uniform/stock/receive/", withCompany(params))
}

// ==================== LOW STOCK ====================
export const getLowStockApi = (params) => {
    return performRequest("get", "api/uniform/stock/low-stock/", params)
}

// ==================== STOCK TRANSACTIONS ====================
export const getStockTransactionsApi = (params) => {
    return performRequest("get", "api/uniform/transactions/", params)
}

// ==================== EMPLOYEE UNIFORM PROFILE ====================
export const getMyUniformProfileApi = (params) => {
    return performRequest("get", "api/uniform/profile/", params)
}

export const getEmployeeUniformProfileApi = (userId, params) => {
    return performRequest("get", `api/uniform/profile/${userId}/`, params)
}

// ==================== PENDING SIZE SELECTION ====================
export const getPendingSizeSelectionApi = (params) => {
    return performRequest("get", "api/uniform/profile/pending/", params)
}

// ==================== SIZE SELECTION ====================
export const submitSizeSelectionApi = (params) => {
    return performRequest("post", "api/uniform/profile/select/", withCompany(params))
}

// ==================== SIZE CHANGE ====================
export const changeSizeApi = (params) => {
    return performRequest("put", "api/uniform/profile/change-size/", withCompany(params))
}

// ==================== SIZE CHANGE HISTORY ====================
export const getSizeChangeHistoryApi = (userId, params) => {
    return performRequest("get", `api/uniform/profile/${userId}/history/`, params)
}

// ==================== ISSUANCE ====================
export const getIssuancesApi = (params) => {
    return performRequest("get", "api/uniform/issuance/", params)
}

export const getIssuanceDetailApi = (id, params) => {
    return performRequest("get", `api/uniform/issuance/${id}/`, params)
}

export const createIssuanceApi = (params) => {
    return performRequest("post", "api/uniform/issuance/", withCompany(params))
}

// ==================== BULK ISSUANCE ====================
export const getBulkIssuanceMetaApi = (params) => {
    return performRequest("get", "api/uniform/issuance/bulk/meta/", params)
}

export const createBulkIssuanceApi = (params) => {
    return performRequest("post", "api/uniform/issuance/bulk/", withCompany(params))
}

// ==================== DUE REPLACEMENTS ====================
export const getDueReplacementsApi = (params) => {
    return performRequest("get", "api/uniform/issuance/due-replacements/", params)
}

export const exportDueReplacementsApi = (params) => {
    return performRequest("get", "api/uniform/issuance/due-replacements/", { ...params, export: "xlsx" }, true, "blob")
}

// ==================== MY PENDING ISSUANCES (for accept/reject popup) ====================
export const getMyPendingIssuancesApi = (params) => {
    return performRequest("get", "api/uniform/issuance/my-pending/", params)
}

// ==================== ISSUANCE ACCEPT / REJECT ====================
export const acceptIssuanceApi = (id) => {
    return performRequest("post", `api/uniform/issuance/${id}/accept/`)
}

export const rejectIssuanceApi = (id, params) => {
    return performRequest("post", `api/uniform/issuance/${id}/reject/`, withCompany(params))
}

// ==================== REJECTION REVIEW ====================
export const reviewRejectionApi = (id, params) => {
    return performRequest("post", `api/uniform/rejection/${id}/review/`, withCompany(params))
}

// ==================== STOCK TRANSFERS ====================
export const getStockTransfersApi = (params) => {
    return performRequest("get", "api/uniform/stock/transfer/", params)
}

export const createStockTransferApi = (params) => {
    return performRequest("post", "api/uniform/stock/transfer/", withCompany(params))
}

export const completeStockTransferApi = (id) => {
    return performRequest("post", `api/uniform/stock/transfer/${id}/complete/`)
}

export const cancelStockTransferApi = (id) => {
    return performRequest("post", `api/uniform/stock/transfer/${id}/cancel/`)
}

// ==================== STOCK TAKE ====================
export const getStockTakesApi = (params) => {
    return performRequest("get", "api/uniform/stock-take/", params)
}

export const getStockTakeDetailApi = (id, params) => {
    return performRequest("get", `api/uniform/stock-take/${id}/`, params)
}

export const createStockTakeApi = (params) => {
    return performRequest("post", "api/uniform/stock-take/", withCompany(params))
}

export const updateStockTakeApi = (id, params) => {
    return performRequest("put", `api/uniform/stock-take/${id}/`, withCompany(params))
}

export const completeStockTakeApi = (id) => {
    return performRequest("post", `api/uniform/stock-take/${id}/complete/`)
}

// ==================== EMPLOYEE UNIFORM CARD ====================
export const getEmployeeUniformCardApi = (userId, params) => {
    return performRequest("get", `api/uniform/employee-card/${userId}/`, params)
}

// ==================== REPORTS ====================
export const getInventoryReportApi = (params) => {
    return performRequest("get", "api/uniform/reports/inventory/", params)
}

export const getEmployeeHistoryReportApi = (userId, params) => {
    return performRequest("get", `api/uniform/reports/employee-history/${userId}/`, params)
}

export const getLifecycleReportApi = (params) => {
    return performRequest("get", "api/uniform/reports/lifecycle/", params)
}

export const getVarianceReportApi = (params) => {
    return performRequest("get", "api/uniform/reports/variance/", params)
}

export const exportInventoryReportApi = (params) => {
    return performRequest("get", "api/uniform/reports/inventory/", { ...params, export: "xlsx" }, true, "blob")
}

export const exportVarianceReportApi = (params) => {
    return performRequest("get", "api/uniform/reports/variance/", { ...params, export: "xlsx" }, true, "blob")
}

export const exportLifecycleReportApi = (params) => {
    return performRequest("get", "api/uniform/reports/lifecycle/", { ...params, export: "xlsx" }, true, "blob")
}
